import { reducer as fromOfferReducer } from './core/states/offer/offer.reducer';
import { reducer as fromAppReducer } from './core/states/app/app.reducer';
import { reducer as fromMedicSearchReducer } from './core/states/medic-search/medic-search.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { OfferState } from './core/states/offer/offer.state';
import { AppState } from './core/states/app/app.state';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { MedicSearchState } from './core/states/medic-search/medic-search.state';

export interface SSCState {
  offer?: OfferState;
  app?: AppState;
  router: RouterReducerState;
  medicSearch?: MedicSearchState;
}

export const reducers: ActionReducerMap<SSCState> = {
  offer: fromOfferReducer,
  app: fromAppReducer,
  medicSearch: fromMedicSearchReducer,
  router: routerReducer,
};
